import React from 'react';
import PropTypes from 'prop-types';
import { map, isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

const AccountPlayerProfile = ({ accountPlayer }) => {
  const { t } = useTranslation();
  const rows = map(accountPlayer.profileAnswers, a =>
    <tr key={`lp-${a.id}`}>
      <td>{a.question}</td>
      <td>{a.answer}</td>
    </tr>
  )
  return (
    <div className='o-dashboard-card__wrap'>
      <strong>{t('accountPlayer.learningProfileQuestion')}</strong>
      <div className='u-margin-top--small cs-bg--light table-scroll'>
        <table className='o-table o-table--bordered'>
          <thead>
            <tr>
              <th>{t('accountPlayer.question')}</th>
              <th>{t('accountPlayer.answer')}</th>
            </tr>
          </thead>
          <tbody>
            { isEmpty(rows) ? <tr><td className='text-center' colSpan='2'>{t('accountPlayer.noData')}</td></tr> : rows }
          </tbody>
        </table>
      </div>
    </div>
  );
}

AccountPlayerProfile.propTypes = {
  accountPlayer: PropTypes.object.isRequired,
}

export default AccountPlayerProfile;
